import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { DashboardPeriod, DateRange, getCustomRange, getPresetRange } from '@app/areas/dashboard/utils/date-range.util';

/** Tab order — index 2 (YEAR) is the default active tab. */
const TAB_PERIODS: DashboardPeriod[] = ['week', 'month', 'year', 'custom'];
const DEFAULT_TAB_INDEX = 2;

/**
 * Week / Month / Year / Custom date tabs. Emits a [from, to) UTC range whenever
 * the selection changes.
 */
@Component({
  selector: 'app-dashboard-date-tabs',
  templateUrl: './dashboard-date-tabs.component.html',
  styleUrls: ['./dashboard-date-tabs.component.scss'],
  standalone: true,
  imports: [NgIf, FormsModule, TabViewModule, CalendarModule, ButtonModule],
})
export class DashboardDateTabsComponent implements OnInit {
  @Output() rangeChange = new EventEmitter<DateRange>();

  activeIndex = DEFAULT_TAB_INDEX;
  customRange: Date[] | null = null;

  ngOnInit(): void {
    this.emitPreset('year');
  }

  onTabChange(index: number): void {
    this.activeIndex = index;
    const period = TAB_PERIODS[index];
    if (period !== 'custom') {
      this.emitPreset(period);
    }
  }

  applyCustomRange(): void {
    const [from, to] = this.customRange ?? [];
    if (from && to) {
      this.rangeChange.emit(getCustomRange(from, to));
    }
  }

  private emitPreset(period: Exclude<DashboardPeriod, 'custom'>): void {
    this.rangeChange.emit(getPresetRange(period, new Date()));
  }
}
